import { render } from "./UserRegisterConfirm.vue?vue&type=template&id=236e73a6&scoped=true"
import script from "./UserRegisterConfirm.vue?vue&type=script&lang=js"
export * from "./UserRegisterConfirm.vue?vue&type=script&lang=js"

import "./UserRegisterConfirm.vue?vue&type=style&index=0&id=236e73a6&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236e73a6"]])

export default __exports__